<template>
	<div style="height: 100%" class="d-flex">
		<div class="centerDiv">
			<v-card max-width="800" class="pa-4">
				<v-card-text class="text-center">
					<v-icon color="primary" large
						>mdi-emoticon-sad-outline</v-icon
					>
					<div class="text-center">
						<span class="text-h2 font-weight-thin"
							>Oops! You are not authorized to access this page.
							Please contact your administrator.</span
						>
					</div>
				</v-card-text>

				<v-card-actions style="justify-content: center">
					<v-btn color="primary" autofocus @click.prevent="onOk">
						OK
					</v-btn>
				</v-card-actions>
			</v-card>
		</div>
	</div>
</template>
<script>
export default {
	name: 'RestrictedAccess',
	methods: {
		onOk() {
			this.$router.push({ name: 'Homepage' });
		},
	},
};
</script>
<style scoped>
.centerDiv {
	display: flex;
	flex-grow: 1;
	justify-content: center;
	align-content: center;
	flex-wrap: wrap;
}
</style>
